import { TaboolaStateManager } from './taboolaStateManager.jsx';

const props = [
    'pageId'
];
export const TaboolaStateManagerDirective = (reactDirective) => reactDirective(TaboolaStateManager, props);
TaboolaStateManagerDirective.$inject = ['reactDirective'];
angular.module('WB.App').directive('taboolaStateManager', TaboolaStateManagerDirective);